const CONST = {
    OBJECT_TYPE: {
        PEN_AUX: "penAux",
        CIRCLE: "circle",
        LINE: "line",
        PATH: "path"
    },
    POINT_TYPE: {
        STRAIGHT: "straight",
        MIRRORED: "mirrored",
        DISJOINTED: "disjointed"
    },
    CONTROL_TYPE: {
        LEFT: "handleA",
        RIGHT: "handleB",
        MAIN: "main"
    },
    PATH_STATE: {
        NEW: "new"
    },
    CURSOR_TYPE: {
        ADD: 'add',
        NORMAL: 'normal',
        MOVE: 'move',
        CLOSE: 'close',
        DEFAULT: 'default'
    }
}
export default CONST;